import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { Building2, Plus, Trash2, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { conciergeApi, errMsg } from "@/components/concierge/api";
import { CompanyClients } from "@/components/concierge/CompanyClients";

export const CompanySection = ({ onOpen, current, setCurrent }) => {
  const [companies, setCompanies] = useState([]);
  const [name, setName] = useState("");

  const load = useCallback(async () => {
    const res = await conciergeApi.get("/companies");
    setCompanies(res.data);
  }, []);

  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    try {
      await conciergeApi.post("/companies", { name });
      toast.success("Entreprise créée");
      setName("");
      load();
    } catch (error) {
      toast.error(errMsg(error));
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Retirer l'entreprise ${c.name} et ses clients de la liste ? (les bons restent dans l'historique)`)) return;
    await conciergeApi.delete(`/companies/${c.id}`);
    load();
  };

  if (current) return <CompanyClients company={current} onBack={() => setCurrent(null)} onOpen={onOpen} />;

  return (
    <div className="space-y-4" data-testid="concierge-company-section">
      <form onSubmit={add} className="flex gap-2">
        <Input placeholder="Nom de la nouvelle entreprise" value={name} onChange={(e) => setName(e.target.value)} required data-testid="company-name-input" />
        <Button type="submit" className="bg-pink-600 hover:bg-pink-700" data-testid="company-add-btn"><Plus className="w-4 h-4 mr-1" />Nouvelle entreprise</Button>
      </form>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {companies.map((c) => (
          <div key={c.id} className="flex items-center gap-3 bg-white border rounded-xl p-3 hover:border-pink-300" data-testid={`company-row-${c.id}`}>
            <button className="flex-1 flex items-center gap-2 text-left font-semibold" onClick={() => setCurrent(c)} data-testid={`company-open-${c.id}`}>
              <Building2 className="w-5 h-5 text-pink-600" />{c.name}
            </button>
            <Button variant="ghost" size="icon" className="text-red-500" onClick={() => remove(c)} data-testid={`company-delete-${c.id}`}><Trash2 className="w-4 h-4" /></Button>
            <ChevronRight className="w-5 h-5 text-slate-400" />
          </div>
        ))}
      </div>
      {companies.length === 0 && <p className="text-center text-slate-400 py-6">Aucune entreprise</p>}
    </div>
  );
};
